import { getMapper, postMapper } from '..';
import {
  ChangeBonusTreeFeaturesRequestDto,
  ChangeBonusTreeNameRequestDto,
  CheckInviteCodeRequestDto,
  CheckNextRewardResponse,
  CheckNextRewardsResponseObject,
  ClaimAdditionalRewardsResponse,
  ClaimBonusTreeRewardsResponse,
  ClaimQuestRewardRequestDto,
  ClaimQuestRewardResponse,
  GenerateInviteCodeResponse,
  GetBonusTreeSeasonsResponse,
  GetEarnedByReferalsRequestDto,
  GetLeaderboardRequestDto,
  GetLeaderboardResponse,
  GetQuestsInfoRequestDto,
  GetQuestsInfoResponse,
  GetRewardsHistoryResponse,
  GetStatResponse,
  GetUserPositionBySeasonRequestDto,
  GetUserPositionBySeasonResponse,
  GetWelcomeBonusRequestDto,
  HttpBoolResponse,
  HttpNumberResponse,
  HttpStringResponse,
} from '../Api';

export const bonusGameApi = {
  checkAvailability: getMapper<void, HttpBoolResponse>('checkAvailability'),
  getStat: getMapper<void, GetStatResponse>('getStat'),
  claimRewards: postMapper<void, ClaimBonusTreeRewardsResponse>('claimRewards'),
  getWelcomeBonus: postMapper<GetWelcomeBonusRequestDto, HttpBoolResponse>(
    'getWelcomeBonus',
  ),
  checkNextReward: getMapper<void, CheckNextRewardsResponseObject>(
    'checkNextReward',
  ),
  changeName: postMapper<ChangeBonusTreeNameRequestDto, HttpBoolResponse>(
    'changeName',
  ),
  getLeaderBoard: postMapper<GetLeaderboardRequestDto, GetLeaderboardResponse>(
    'getLeaderBoard',
  ),
  resetDate: getMapper<void, HttpStringResponse>('resetDate'),
  claimAdditionalRewards: postMapper<void, ClaimAdditionalRewardsResponse>(
    'claimAdditionalRewards',
  ),
  getRewardsHistory: getMapper<void, GetRewardsHistoryResponse>(
    'getRewardsHistory',
  ),
  changeFeatures: postMapper<
    ChangeBonusTreeFeaturesRequestDto,
    HttpBoolResponse
  >('changeFeatures'),

  getSeasons: getMapper<void, GetBonusTreeSeasonsResponse>('getSeasons'),
  generateInviteCode: postMapper<void, GenerateInviteCodeResponse>(
    'generateInviteCode',
  ),

  getEarnedByReferals: postMapper<
    GetEarnedByReferalsRequestDto,
    HttpNumberResponse
  >('getEarnedByReferals'),
  getQuestsInfo: postMapper<GetQuestsInfoRequestDto, GetQuestsInfoResponse>(
    'getQuestsInfo',
  ),
  claimQuestReward: postMapper<
    ClaimQuestRewardRequestDto,
    ClaimQuestRewardResponse
  >('claimQuestReward'),
  getPositionBySeason: postMapper<
    GetUserPositionBySeasonRequestDto,
    GetUserPositionBySeasonResponse
  >('getPositionBySeason'),
  checkInviteCode: postMapper<CheckInviteCodeRequestDto, { result: boolean }>(
    'checkInviteCode',
  ),
};
